import React from 'react';
import { Root as MenuRoot } from '@radix-ui/react-dropdown-menu';
import { bool, node } from 'prop-types';

var Menu = function Menu(_ref) {
  var children = _ref.children,
      onMouseHover = _ref.onMouseHover;

  var _React$useState = React.useState(false),
      isOpen = _React$useState[0],
      setIsOpen = _React$useState[1];

  function handleOpenMenu() {
    setIsOpen(!isOpen);
  }

  if (!onMouseHover) {
    return /*#__PURE__*/React.createElement(MenuRoot, {
      sideOffset: 5,
      modal: false
    }, children);
  }

  return /*#__PURE__*/React.createElement("div", {
    onMouseEnter: handleOpenMenu,
    onMouseLeave: handleOpenMenu
  }, /*#__PURE__*/React.createElement(MenuRoot, {
    sideOffset: 5,
    modal: false,
    defaultOpen: true,
    open: isOpen
  }, children));
};

Menu.propTypes = {
  children: node.isRequired,

  /** when mouse hover menu open as deafault is true */
  onMouseHover: bool
};
Menu.defaultProps = {
  onMouseHover: true
};
Menu.displayName = 'Menu';
export default Menu;